module.exports = __webpack_public_path__ + "static/media/ma_programs.20007246.jpg";